function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useErrorHandling } from '../hooks/useErrorHandling';
import { createTimezonedDate } from '../util/date';
import { EditButtonsSet } from '../util';
import generalRouteService from '../services/general_route.service';
import FolderFileIcon from './FolderFileIcon';
import { SHOW_EDIT_BUTTON_FOR_RESTRICTED_FOLDER } from '@rd-web-markets/market/dist/constants';
import { FILE_MANAGEMENT_COLUMN_ORDER } from '@rd-web-markets/market/dist/constants';
import ongoingTemplateImportService from '@services/claim_groups/ongoing_template_import.service';
import projectTemplateImportService from '@services/claim_groups/project_template_import.service';
import { useSelector } from 'react-redux';
const fileShortcutModelNames = ['BeSection::OngoingTemplateImport', 'BeSection::ProjectTemplateImport'];
const apiFilePathsToShortcutFiles = {
  'BeSection::OngoingTemplateImport': {
    service: ongoingTemplateImportService,
    routeIds: ['parent_of_parent_id', 'parent_attachment_model_id']
  },
  'BeSection::ProjectTemplateImport': {
    service: projectTemplateImportService,
    routeIds: ['parent_of_parent_id', 'parent_attachment_model_id']
  }
};
const FoldersAndFilesRow = _ref => {
  let {
    data,
    route,
    setAllData,
    allData,
    setCurrentFolderId,
    goToFolderQuery,
    canEditExistingDocumentsOrFolders = true
  } = _ref;
  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [body, setBody] = useState(_objectSpread({}, data));
  const user = useSelector(state => state.auth.user);
  const canEditOrDelete = useCallback(() => {
    if (user.account_type === 'admin' || user.account_type === 'super_consultant') return true;
    if (user.account_type === 'customer' || user.account_type === 'consultant') {
      return body.uploaded_by_user_id === user.id;
    }
    return true;
  }, [user, body]);
  const showEditIfRestricted = body.restricted ? SHOW_EDIT_BUTTON_FOR_RESTRICTED_FOLDER : true;
  const changeBody = event => {
    const value = event.target.value;
    setBody(_objectSpread(_objectSpread({}, body), {}, {
      [event.target.name]: value
    }));
  };
  const deleteData = useErrorHandling(useCallback(async () => {
    if (window.confirm("Would you like to delete \"".concat(body.name, "\"?"))) {
      if (fileShortcutModelNames.includes(data.file_parent_class_name)) {
        const service = apiFilePathsToShortcutFiles[data.file_parent_class_name].service;
        const routeIds = apiFilePathsToShortcutFiles[data.file_parent_class_name].routeIds.map(r => data[r]);
        await service.delete(...routeIds);
      } else {
        await generalRouteService.delete(route, data.id);
      }
      setAllData(prevData => prevData.filter(item => item.id !== data.id));
    }
    setEditing(false);
  }, [body, data, route, setAllData]));
  const updateData = useErrorHandling(useCallback(async () => {
    const payload = {
      name: body.name,
      notes: body.notes,
      is_financial: body.is_financial || false,
      is_technical: body.is_technical || false,
      is_internal_only: body.is_internal_only || false
    };
    const response = await generalRouteService.update(route, data.id, payload);
    setBody(_objectSpread({}, response));
    setEditing(false);
  }, [body]));
  const renderNotes = editing ? /*#__PURE__*/React.createElement(Form.Control, {
    name: "notes",
    as: "textarea",
    maxLength: "300",
    style: {
      resize: 'none'
    },
    value: body.notes,
    onChange: changeBody
  }) : body.notes;
  const goToFolder = () => {
    if (editing || route !== 'folders') return;
    const isVirtualFolder = body.virtual_folder;
    if (isVirtualFolder) {
      goToFolderQuery(body.id, isVirtualFolder, body);
    } else if (route === 'folders') {
      setCurrentFolderId(body.id);
      goToFolderQuery(body.id);
    }
  };
  const renderNameOrLink = () => {
    if (Object.prototype.hasOwnProperty.call(body, 'download_link')) {
      return /*#__PURE__*/React.createElement("a", {
        href: body.download_link.url,
        target: "_blank",
        rel: "noreferrer"
      }, body.name);
    } else {
      return body.name;
    }
  };
  const pointerClass = route === 'folders' ? 'cursor-pointer' : '';
  const cursorMove = {
    cursor: 'move'
  };
  const renderColumn = columnName => {
    var _body$download_link;
    switch (columnName) {
      case 'folderIcon':
        return /*#__PURE__*/React.createElement("td", {
          onClick: () => goToFolder(),
          className: pointerClass
        }, /*#__PURE__*/React.createElement(FolderFileIcon, {
          isFile: Object.prototype.hasOwnProperty.call(body, 'notes'),
          contentType: body === null || body === void 0 || (_body$download_link = body.download_link) === null || _body$download_link === void 0 ? void 0 : _body$download_link.content_type
        }));
      case 'createdAt':
        return /*#__PURE__*/React.createElement("td", {
          onClick: () => goToFolder(),
          className: pointerClass
        }, createTimezonedDate(body.created_at).toCustomLocaleDateString());
      case 'name':
        return /*#__PURE__*/React.createElement("td", {
          onClick: () => goToFolder(),
          className: pointerClass
        }, editing ? /*#__PURE__*/React.createElement(Form.Control, {
          name: "name",
          value: body.name,
          size: "md",
          type: "text",
          onChange: changeBody
        }) : renderNameOrLink());
      case 'fileType':
        return /*#__PURE__*/React.createElement("td", {
          style: cursorMove
        }, !body.virtual_folder && (editing && user.account_type !== 'customer' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Check, {
          type: "checkbox",
          label: "Financial",
          checked: body.is_financial || false,
          onChange: e => setBody(prev => _objectSpread(_objectSpread({}, prev), {}, {
            is_financial: e.target.checked
          }))
        }), /*#__PURE__*/React.createElement(Form.Check, {
          type: "checkbox",
          label: "Technical",
          checked: body.is_technical || false,
          onChange: e => setBody(prev => _objectSpread(_objectSpread({}, prev), {}, {
            is_technical: e.target.checked
          }))
        }), /*#__PURE__*/React.createElement(Form.Check, {
          type: "checkbox",
          label: "Internal Only",
          checked: body.is_internal_only || false,
          onChange: e => setBody(prev => _objectSpread(_objectSpread({}, prev), {}, {
            is_internal_only: e.target.checked
          }))
        })) : [body.is_financial && 'Financial', body.is_technical && 'Technical', body.is_internal_only && 'Internal Only'].filter(Boolean).join(', ')));
      case 'notes':
        return /*#__PURE__*/React.createElement("td", {
          style: cursorMove
        }, Object.prototype.hasOwnProperty.call(body, 'notes') && renderNotes);
      case 'uploadedBy':
        return /*#__PURE__*/React.createElement("td", {
          style: cursorMove
        }, Object.prototype.hasOwnProperty.call(body, 'uploaded_by') && body.uploaded_by);
      case 'editButton':
        return /*#__PURE__*/React.createElement("td", null, !body.virtual_folder && showEditIfRestricted && canEditExistingDocumentsOrFolders && canEditOrDelete() && /*#__PURE__*/React.createElement(EditButtonsSet, {
          editing: editing,
          setEditing: setEditing,
          handleDelete: deleteData,
          handleUpdate: updateData,
          deleteProps: body.id,
          loading: loading
        }));
      default:
        return /*#__PURE__*/React.createElement("div", null, columnName, " does not exist");
    }
  };
  return FILE_MANAGEMENT_COLUMN_ORDER.map(columnName => renderColumn(columnName));
};
export default FoldersAndFilesRow;